import React from 'react'

function PointsRadiobuttons({ options, radioButtonsName, setSelectedOption, selectedOption }) {
  // const [selectedOption, setSelectedOption] = useState('')

  const handleOptionChange = event => {
    setSelectedOption(event.target.value)
  }

  return (
    <div className=' d-flex' style={{ gap: '10px', flexWrap: 'wrap' }}>
      {options.map((option, index) => (
        <div key={index} className='form-check'>
          <input
            className='form-check-input'
            type='radio'
            name={radioButtonsName}
            id={`${option}`}
            value={option}
            checked={selectedOption === option}
            onChange={handleOptionChange}
          />
          <label className='form-check-label' htmlFor={option}>
            {option}
          </label>
        </div>
      ))}
      {/* <p>Selected Option: {selectedOption}</p> */}
    </div>
  )
}

export default PointsRadiobuttons
